
import {JSONPath} from "jsonpath";
function transformer(value, params) {
    if(params){
        return new JSONPath().query(value, params);
    }else{
        return value;
    }
    
}

export {transformer}